module.exports = __webpack_public_path__ + "img/Bodice-Back-Jc-Kj-Lb.3ab83296.png";